import * as React from 'react';
import { HIT_AD } from '@/src/sub_packages/common/BaseComponent/adReport';
import './index.css';

interface FlexibleObject {
  [key: string]: any;
}

interface Props {
  /**
   * 广告数据字段
   */
  adInfo: FlexibleObject;
}

interface State {}

/**
 * 广告标组件
 * 显隐在组件内控制
 */
export default class AdFlagContainer extends React.PureComponent<Props, State> {
  renderComponent = (expKey) => {
    switch (expKey) {
      case 'C':
        // AD标
        return (
          <view className="ad-flag-tag">
            <text className="ad-flag-tag-text">{this.props.adInfo?.adLabel || 'Ad'}</text>
          </view>
        );
      case 'D':
        // 赞助标
        return (
          <view className="ad-flag-sponsor">
            <text className="ad-flag-sponsor-text">{this.props.adInfo?.adLabel || '赞助'}</text>
          </view>
        );
      default:
        // 暗点
        return <view className="ad-flag-dot" />;
    }
  };

  render() {
    // 非广告不展示
    const hitAd = this.props.adInfo?.hitAd === HIT_AD;
    if (!hitAd) return null;

    // 广告标实验
    const expKey = this.props.adInfo?.expKey || 'A';

    return <>{this.renderComponent(expKey)}</>;
  }
}
